import { useState, useEffect } from 'react';
import { useLeadForm } from './context/leadform';

export const capitaliseFirstLetter = (string: string): string => {
    return string.charAt(0).toUpperCase() + string.slice(1);
}

export const stripNonAlphanumeric = (string: string): string => {
    return string.replace(/[^a-z0-9]/gi, '');
}

export const useDebounce = (value: any, delay: number) => {
    const [debouncedValue, setDebouncedValue] = useState(value);

    useEffect(() => {
        // Set debouncedValue to value (passed in) after the specified delay
        const handler = setTimeout(() => {
            setDebouncedValue(value);
        }, delay);

        return () => {
            clearTimeout(handler);
        };
    }, [value, delay]);

    return debouncedValue;
}

// Send google analytics event on render
export const useGAEvent = () => {
    const { steps, step } = useLeadForm();
    useEffect(() => {
        try {
            if (!steps || typeof steps === 'undefined') {
                console.warn("Steps is undefined, skipping gtag call");
                return;
            }

            if (window.gtag && typeof window.gtag === 'function') {
                const stepName = steps[step]?.name; // Optional chaining to avoid errors
                if (!stepName) {
                    console.warn("stepName is undefined, skipping gtag call");
                    return;
                }
                window.gtag('event', stepName, { non_interaction: true });
            } else {
                console.warn('gtag function not found on window');
            }
        } catch (e) {
            console.log(e);
        }
    }, [steps, step])
}
